import { removeSessionToken } from '../../../actions/Auth'
import store from '../../../store'
import { UT } from 'core/constants'

const hooks = {
  onLoginRequired: () => {
    if (store.account.type === UT.ADMIN) { return }
    removeSessionToken()
  },
  onRequestError(data = {}) {
    console.error(`apiError - ${data.endpoint || ''}`, {
      endpoint: data.endpoint,
      statusCode: data.statusCode,
      error: data.response,
    })
  }
}

export default hooks
